import { useEffect, useState } from 'react'
import type { AnswerValue, PhaseInfo, WorkflowStage } from '../../types/workflow'
import { getArrayVariable, getTextVariable } from './template-variable-utils'

interface RadioOption {
  id: string
  label: string
  description?: string
}

interface RadioCardsTemplateProps {
  stage: WorkflowStage
  initialValue?: string
  onSelect: (value: AnswerValue) => void
  currentPhase?: PhaseInfo | null
}

function choiceBtn(active: boolean) {
  return `w-full py-4 px-[18px] text-[15px] font-medium text-[var(--ww-text)] text-left rounded-2xl cursor-pointer transition-all duration-300 border glass hover:border-[var(--ww-border-hover)] hover:bg-[var(--ww-surface-2)] hover:-translate-y-px ${
    active
      ? 'border-[var(--ww-accent)] choice-selected shadow-[0_0_16px_rgba(74,138,154,0.12),inset_0_1px_0_rgba(74,138,154,0.15)] selected-glow'
      : 'border-[var(--ww-glass-border)] bg-[var(--ww-surface)]'
  }`
}

export default function RadioCardsTemplate({
  stage,
  initialValue,
  onSelect,
}: RadioCardsTemplateProps) {
  const [selected, setSelected] = useState(initialValue || '')
  const options = getArrayVariable<RadioOption>(stage.templateVariables, 'options', [])

  useEffect(() => {
    if (initialValue !== undefined) setSelected(initialValue)
  }, [initialValue])

  const handleOptionChange = (value: string) => {
    setSelected(value)
    onSelect(value)
  }

  return (
    <div className="flex-1 flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        {options.map((option) => (
          <button
            key={option.id}
            className={choiceBtn(selected === option.id)}
            onClick={() => handleOptionChange(option.id)}
            type="button"
          >
            <div className="flex flex-col">
              <span>{option.label}</span>
              {option.description && (
                <span className="text-sm font-normal text-[var(--ww-text-2)] mt-0.5">{option.description}</span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}
